import React from 'react';
import { NextPage } from 'next';
import Layout from '../../components/layout';
import Mode06Container from '../../components/mode-06-container';
import GenericContainer from '../../components/@container/generic-container';

const Mode06Page: NextPage = () => (
  <Layout title="Mode $06">
    <GenericContainer
      title="Mode $06"
      breadcrumb={{ url: '/resources', text: 'Back to Resources' }}
    >
      <div className="content">
        <Mode06Container />
      </div>
    </GenericContainer>
  </Layout>
);

export default Mode06Page;
